import axiosInstance from "./axiosInstance";

export const getCategories = async () => {
  const { data } = await axiosInstance.get("/category/getAll");
  return data.status ? data.data : [];
};

export const getProductsByCategory = async (categoryId, page = 1, limit = 50) => {
  const { data } = await axiosInstance.get(`/product/getAllPagination?categoryId=${categoryId}&pageNumber=${page}&pageSize=${limit}`);
  return data.status ? data.data.productList : [];
};

export const getAllProducts = async () => {
  const { data } = await axiosInstance.get("/product/getAll");
  return data.status ? data.data : [];
};

export const getProductBySlug = async (slug) => {
  const { data } = await axiosInstance.get(`/product/getBySlug/${slug}`);
  return data.status ? data.data : null;
};

export const getContentBySlug = async (slug) => {
  const { data } = await axiosInstance.get(`/content/getBySlug/${slug}`);
  return data.status ? data.data : null;
};

export const getPublishedReviews = async () => {
  const { data } = await axiosInstance.get("/review/published");
  return data.status ? data.data : [];
};

export const getProjects = async (categoryId = "") => {
  const { data } = await axiosInstance.get(`/projects/getAllPagination?categoryId=${categoryId}&isPublish=true&pageSize=100`);
  return data.status ? data.data.projectList : [];
};

export const saveInquiry = async (formData) => {
  const { data } = await axiosInstance.post("/inquiry/save", formData);
  return data.status;
};

export const getBannerByPage = async (pageName) => {
  const { data } = await axiosInstance.get(`/banner/getByPage/${pageName}`);
  return data.status ? data.data : null;
};

export const getSiteSettings = async () => {
  const { data } = await axiosInstance.get("/site-settings");
  return data.status ? data.data : null;
};

export default axiosInstance;
